// src/theme/spacing.js

export  const spacing = {
  xxs: "4px",
  xs: "8px",
  sm: "12px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  xxl: "40px",
  l: "48px",
  "2xl": "64px",
  "3xl": "80px",
  "4xl": "96px",
  m: "100px",
  ml: "120px",
};

